<template>
<div>
<div v-for="(value, name, index) in product.lmr" :key="index">
  <p class="font-semibold mb-2 uppercase">{{ name }} </p>
    <ul v-for="(value, name) in value" :key="name" class="md:ml-12">
      <li class="mb-1">{{name}} : {{value.info_avant_lmr}}<span v-if="value.info_avant_lmr == 'Non fixé'"> (LMR générale par défaut : 0.01 mg/kg)</span> <span v-if="value.lmr != null">{{value.lmr}} mg/kg</span> {{value.info_apres_lmr}}</li>
    </ul> 
</div>
  
</div>

</template>

<script>
export default {
    name: 'ProductLMR',
    props: {
    product: Object
  },
}
</script>

<style>

</style>